<ins-insurance-end-product-data
    [purchasedProduct]="purchasedProduct"
    [endProductForm]="endProductForm"
    [endDateProductForm]="endDateProductForm"
></ins-insurance-end-product-data>
<ins-panel-expandable direction="right" #endProductForm="panel" [hasBorder]="false">
    <wuc-balloon
        [arrowPosition]="(isScreenSmall$ | async) ? 'topLeft' : 'topRight'"
        padding="large"
        [isFullWidth]="true"
    >
        <ins-insurance-end-product-form
            *ngIf="!isVehicle"
            [purchasedProduct]="purchasedProduct"
        ></ins-insurance-end-product-form>
        <ins-insurance-end-product-vehicle-form
            *ngIf="isVehicle"
            [purchasedProduct]="purchasedProduct"
        ></ins-insurance-end-product-vehicle-form>
    </wuc-balloon>
</ins-panel-expandable>
<ins-panel-expandable direction="right" #endDateProductForm="panel" [hasBorder]="false">
    <wuc-balloon
        [arrowPosition]="(isScreenSmall$ | async) ? 'topLeft' : 'topRight'"
        padding="large"
        [isFullWidth]="true"
    >
        <ins-insurance-end-date-product-form
            [purchasedProduct]="purchasedProduct"
        ></ins-insurance-end-date-product-form>
    </wuc-balloon>
</ins-panel-expandable>
